import logo from './logo.svg';
import './App.css';
import Week from './components/Week'
import ListItem from './components/ListItem'
import ButtonFooter from './components/ButtonFooter'
import CreateTask from './components/CreateTask';
import TaskDetails from './components/TaskDetails';
import List from './components/List';
import { Helmet } from 'react-helmet';
import FilterTasks from './components/FilterTasks';

function getTasks() {
  var tasks = JSON.parse(localStorage.getItem('tasks'));
  if (tasks == null) {
    tasks = [];
  }
  tasks.sort(function (a, b) {
    return new Date(a.date) - new Date(b.date);
  });
  return tasks;
}

function createListItems() {
  var tasks = getTasks();
  var listItems = [];
  for (var i = 0; i < tasks.length; i++) {
    var task = tasks[i];
    // convert task date to format like "Feb 1"
    var date = new Date(task.date);
    var month = date.toLocaleString('default', { month: 'short' });
    var day = date.getDate();
    task.date = month + " " + day;
    listItems.push(
      <ListItem
        title={task.name}
        date={task.date}
        time={task.time}
        location={task.location}
        description={task.description}
        id={task.id}
      />
    );
  }
  return listItems;
}

// create a function that re-renders List


// Q: How do I get the list items to render?
// A: You need to return the list items from the render function.
//    You can't just create them and expect them to render.
//    You need to return them from the render function.
const TITLE = 'To-Do List';

function App() {
  return (
    <div className="App">
      <Helmet>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <meta charSet="utf-8" />
        <title>{ TITLE }</title>
        <meta property="og:title" content={ TITLE } />
        <meta property="og:description" content="A to-do list app." />
        <meta property="og:image" content="https://i.imgur.com/4ZQ9Z0M.png" />
      </Helmet>
      {/* <header className="App-header">
        <h1 className='month' id="month">February</h1>
        <Week />
      </header> */}
      <Week />
      <div className="list">
        <CreateTask key="2" />
        <TaskDetails />
        <FilterTasks />

        {/* <ListItem
          title="Create a working to-do list"
          date="Feb 20"
          time="11:59 PM"
          location="Seven Lakes High School"
          description="Create a working to-do list using Electron."
          id="1"
        /> */}

        <List key="1" />

        {/* {createListItems()} */}

      </div>
      <div className="footer">
        <ButtonFooter />
      </div>
    </div>
  );
}

export default App;
